// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalContainer_PZL9f {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--_FFFFFF80-background);
  justify-content: center;
  align-items: center;
  z-index: 9999;
  transition: opacity 300ms ease-in-out;
  -webkit-transition: opacity 300ms ease-in-out;
  -moz-transition: opacity 300ms ease-in-out;
  -ms-transition: opacity 300ms ease-in-out;
  -o-transition: opacity 300ms ease-in-out;
}
.upgradePlanContainer_b_M2E {
  background: var(--white-background);
  border-radius: 8px;
  width: 360px;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  font-family: "Inter", sans-serif;
  box-shadow: 0 4px 15px var(--_00000033-shadow);
  transform: scale(1);
  animation: scaleUp_s85cl 300ms ease-out forwards;
  overflow-y: scroll;
  .upgradeContainer_RCFJJ{
    overflow-y: scroll;
    display: flex;
    padding: 20px 24px;
    flex-direction: column;
  }
}

.scaleDown_j2L22 {
  animation: scaleDown_j2L22 300ms ease-in forwards;
  -webkit-animation: scaleDown_j2L22 300ms ease-in forwards;
}

@keyframes scaleUp_s85cl {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

@keyframes scaleDown_j2L22 {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(0);
  }
}

.fadeOut_eG6IT {
  opacity: 0;
}

.header_PdRKc {
  display: flex;
  justify-content: space-between;
  padding: 0;
  margin: 0;
  align-items: center;
}

.label_cvchH {
  font-size: 14px;
  font-weight: 500;
  color: #0c1421;
  position: relative;
}

.input_I8m5q {
  margin-top: 8px;
  display: flex;
  width: 100%;
  max-width: 388px;
  padding: 10px 14px;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  color: #8897ad;
  border: none !important;
  outline: none !important;
  background-color: var(--f4-background);
  height: 48px;
  box-sizing: border-box;
}

.closeButton_fRjLT {
  margin-top: 6px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.passwordRequirements_uX1ib {
  position: absolute;
  top: 16px;
  left: 0;
  color: #8897ad;
  font-size: 9px;
}

.signInButton_FJDnb {
  width: 100%;
  max-width: 388px;
  background-color: #162d3a;
  color: var(--white-background);
  font-size: 18px;
  font-weight: 400;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  /* margin-bottom: 28px; */
  display: flex;
  min-height: 48px;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/AddAdminModal/AddAdminModal.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,6CAA6C;EAC7C,0CAA0C;EAC1C,yCAAyC;EACzC,wCAAwC;AAC1C;AACA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;EAChC,8CAA8C;EAC9C,mBAAmB;EACnB,gDAA0C;EAC1C,kBAAkB;EAClB;IACE,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;EACxB;AACF;;AAEA;EACE,iDAA2C;EAC3C,yDAAmD;AACrD;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,UAAU;EACV,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,sCAAsC;EACtC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".modalContainer {\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: var(--_FFFFFF80-background);\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n  transition: opacity 300ms ease-in-out;\n  -webkit-transition: opacity 300ms ease-in-out;\n  -moz-transition: opacity 300ms ease-in-out;\n  -ms-transition: opacity 300ms ease-in-out;\n  -o-transition: opacity 300ms ease-in-out;\n}\n.upgradePlanContainer {\n  background: var(--white-background);\n  border-radius: 8px;\n  width: 360px;\n  display: flex;\n  flex-direction: column;\n  max-height: 90vh;\n  font-family: \"Inter\", sans-serif;\n  box-shadow: 0 4px 15px var(--_00000033-shadow);\n  transform: scale(1);\n  animation: scaleUp 300ms ease-out forwards;\n  overflow-y: scroll;\n  .upgradeContainer{\n    overflow-y: scroll;\n    display: flex;\n    padding: 20px 24px;\n    flex-direction: column;\n  }\n}\n\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n  -webkit-animation: scaleDown 300ms ease-in forwards;\n}\n\n@keyframes scaleUp {\n  from {\n    transform: scale(0);\n  }\n  to {\n    transform: scale(1);\n  }\n}\n\n@keyframes scaleDown {\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(0);\n  }\n}\n\n.fadeOut {\n  opacity: 0;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  padding: 0;\n  margin: 0;\n  align-items: center;\n}\n\n.label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #0c1421;\n  position: relative;\n}\n\n.input {\n  margin-top: 8px;\n  display: flex;\n  width: 100%;\n  max-width: 388px;\n  padding: 10px 14px;\n  border: none;\n  border-radius: 12px;\n  font-size: 14px;\n  color: #8897ad;\n  border: none !important;\n  outline: none !important;\n  background-color: var(--f4-background);\n  height: 48px;\n  box-sizing: border-box;\n}\n\n.closeButton {\n  margin-top: 6px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.passwordRequirements {\n  position: absolute;\n  top: 16px;\n  left: 0;\n  color: #8897ad;\n  font-size: 9px;\n}\n\n.signInButton {\n  width: 100%;\n  max-width: 388px;\n  background-color: #162d3a;\n  color: var(--white-background);\n  font-size: 18px;\n  font-weight: 400;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  /* margin-bottom: 28px; */\n  display: flex;\n  min-height: 48px;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContainer": `modalContainer_PZL9f`,
	"upgradePlanContainer": `upgradePlanContainer_b_M2E`,
	"scaleUp": `scaleUp_s85cl`,
	"upgradeContainer": `upgradeContainer_RCFJJ`,
	"scaleDown": `scaleDown_j2L22`,
	"fadeOut": `fadeOut_eG6IT`,
	"header": `header_PdRKc`,
	"label": `label_cvchH`,
	"input": `input_I8m5q`,
	"closeButton": `closeButton_fRjLT`,
	"passwordRequirements": `passwordRequirements_uX1ib`,
	"signInButton": `signInButton_FJDnb`
};
export default ___CSS_LOADER_EXPORT___;
